module.exports = __webpack_public_path__ + "img/90501207tw.f1230573.png";